import { SynergyCaseStatusStepType } from 'ts/types/config.types';
import { StepTag } from 'ts/types/case-status.types';

export const getStepIndex = (
  steps: StepTag[],
  currentStep: SynergyCaseStatusStepType,
): number => steps.findIndex(step => step.key === currentStep);
